<template>
  <b-tab>
    <template #title>
      <span class="d-none d-sm-inline">Rules</span>
    </template>
    <b-container>

      <div class="mb-2 d-flex justify-content-between align-items-center">
        <b-button
          variant="success"
          @click="validateForm"
        >
          Save Rules Changes
        </b-button>
        <b-button
          variant="primary"
          @click="addNewRulesForm"
        >
          <span>Add new rule</span>

        </b-button>
      </div>

      <validation-observer
        v-for="(el, index) in rulesArr"
        :key="el.localId"
        :ref="`rulesRef-${el.localId}`"
      >
        <b-form>
          <b-row
            class="pb-5 rules_form_style"
          >
            <b-col
              md="12"
              class="d-flex justify-content-end"
            >
              <b-button
                variant="flat"
                @click="deleteRulesForm(index)"
              >
                <feather-icon
                  icon="Trash2Icon"
                  size="25"
                  style="color: #CE224D"
                />
              </b-button>
            </b-col>
            <b-col md="4">
              <validation-provider
                name="from"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="From"
                  :label-for="`from${el.localId}`"
                >
                  <v-select
                    :id="`from${el.localId}`"
                    v-model="el.from"
                    :options="tripStates"
                    :reduce="state => state.key"
                    :clearable="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
              <validation-provider
                name="action by"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Action By"
                  :label-for="`action-by${el.localId}`"
                >
                  <b-form-input
                    :id="`action-by${el.localId}`"
                    v-model="el.action_by"
                    readonly
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <validation-provider
                name="to"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="To"
                  :label-for="`to${el.localId}`"
                >
                  <v-select
                    :id="`to${el.localId}`"
                    v-model="el.to"
                    :options="tripStates"
                    :reduce="state => state.key"
                    :clearable="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
              <validation-provider
                name="value"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Value"
                  :label-for="`val${el.localId}`"
                >
                  <b-form-input
                    :id="`val${el.localId}`"
                    v-model="el.value"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              md="4"
            >
              <validation-provider
                name="metric"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Metric"
                  :label-for="`metric${el.localId}`"
                >
                  <v-select
                    :id="`metric${el.localId}`"
                    v-model="el.metric"
                    :options="metric"
                    :reduce="metric => metric.key"
                    :clearable="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-container>

  </b-tab>
</template>

<script>
import {
  BTab, BContainer, BRow, BCol, BFormInput, BButton, BFormGroup, BForm,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { ref } from '@vue/composition-api'
import { tripStates, metric } from '../../hooks/useStaticOptions'
import { errorNotification, successNotification } from '@/utils/toast-notifications'
import useValidateDynamicForm from '../../hooks/use-validate-dynamic-forms'

export default {
  components: {
    BTab,
    BContainer,
    BRow,
    BCol,
    BFormInput,
    vSelect,
    BButton,
    ValidationObserver,
    ValidationProvider,
    BFormGroup,
    BForm,
  },
  props: {
    rules: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, ctx) {
    const rulesArr = ref([...props.rules.map(el => ({ ...el, localId: Math.random().toString() }))])

    const addNewRulesForm = () => {
      const tempRule = {
        localId: Math.random().toString(),
        from: '',
        to: '',
        action_by: 'driver',
        metric: '',
        value: '',
      }
      rulesArr.value.unshift(tempRule)
    }
    const deleteRulesForm = index => {
      rulesArr.value.splice(index, 1)
    }

    const validateForm = async () => {
      const isValid = await useValidateDynamicForm(ctx)
      if (isValid) {
        ctx.emit('rules-set', rulesArr.value)
        successNotification('Saved...')
      } else {
        errorNotification('Fill out the required fields')
      }
    }

    return {
      required,
      tripStates,
      metric,
      validateForm,
      addNewRulesForm,
      deleteRulesForm,
      rulesArr,
    }
  },
}
</script>

<style scoped>
.rules_form_style{
    border: 3px solid lightgray;
    padding: 20px;
    margin-bottom: 30px;
    border-radius: 20px;
}
</style>
